namespace $.$$ {
	
	$mol_style_define( $hyoo_budget_person_page, {
		
		flex: {
			basis: `20rem`,
		},

		margin: {
			left: 'auto',
		},

		Key: {
			wordBreak: 'break-all',
		},
		
	} )
	
}
